import PasswordField from 'components/forms/fields/password-field/password-field.component';
import UsernameField from 'components/forms/fields/username-field/username-field.component';
import { useTranslation } from 'react-i18next';
import CheckboxField from 'components/forms/fields/checkbox-field/checkbox-field.component';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link } from '@mui/material';

const LoginForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <UsernameField
        name="username"
        label={t('forms.fields.username.label')}
        data-testid="UsernameField"
        autoComplete="username"
      />
      <PasswordField
        name="password"
        label={t('forms.fields.password.label')}
        data-testid="PasswordField"
        autoComplete="current-password"
      />
      <Box display="flex" justifyContent="flex-end">
        <Link
          component={RouterLink}
          to="/login/requestpasswordreset"
          data-testid="Login.ResetPassword"
        >
          {t('page.login.forgotPassword')}
        </Link>
      </Box>
      <CheckboxField
        name="remember"
        label={t('forms.fields.rememberMe.label')}
        data-testid="CheckboxField"
      />
    </>
  );
};

export default LoginForm;
